import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { certificatesActions } from '../actions/certificates.actions';
import { HttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root',
})
export class CertificatesEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getCertificates$ = createEffect(() => {
        return this.actions.pipe(
            ofType(certificatesActions.getCertificates),
            mergeMap(() => {
                return this.httpService.getCertificates().pipe(
                    map((payload) => certificatesActions.getCertificatesSuccess({ payload })),
                    catchError(() => of(certificatesActions.getCertificatesError())),
                );
            }),
        );
    });
}
